<template>
    <div class="ifs011" :style="dBHeight"> 
        <div class="ifs_cnt">
            <h2>{{ $i18nUtil.trans("title.ShareInfoManageDetail.001","카테고리 정보") }}</h2>

            <ul class="list-table">
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.001","카테고리명") }}</dt>
                        <dd>
                            <form action="" @submit.prevent="false == false">
                                <div class="input-box">
                                    <input type="text" required placeholder="" :disabled="!shareInfoManageYn" @focus="delKeyActive=true" @focusout="delKeyActive=false"
                                           v-model="categoryName" @input="displayBytes(maxBytes, categoryName, $event)">
                                    <button type="button" class="input-txt-del" v-if="delKeyActive" @click="categoryName='', error=false, checkBytes=0">입력 삭제</button>
                                    <div class="error" v-if="error">{{ $i18nUtil.trans("message.ShareInfoManageDetail.002","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
                                    <div class="error" v-if="errorFolderName" >{{ $i18nUtil.trans("message.ShareInfoManageDetail.003","카테고리명을 입력해주세요.") }}</div>
                                </div>
                            </form>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.004","공개 여부") }}</dt>
                        <dd>
                            <input type="radio" name="ra" disabled id="ra1" value="NORMAL" v-model="docGrade">
                            <label for="ra1">{{ $i18nUtil.trans("entity.category.docGrade.NORMAL","전체공개") }}</label>
                            <input type="radio" name="ra" disabled id="ra2" value="SECRET" v-model="docGrade">
                            <label for="ra2">{{ $i18nUtil.trans("entity.category.docGrade.RESTRICT","멤버만 공개") }}</label>
                            <span class="ref">{{ $i18nUtil.trans("message.ShareInfoManageDetail.005","* 카테고리 공개 여부는 변경할 수 없습니다.") }}</span>
                        </dd>
                        <dt></dt>
                        <!-- <dd style="color:red;"><span>＊</span>멤버만 공개 설정 시 멤버를 구성할 수 있습니다. 단 설정 이후 '전체공개'로 다시 변경할 수 없습니다.</dd> -->
                    </dl> 
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.006","생성자") }}</dt>
                        <dd>{{ defaultLanguage.indexOf('ko') != -1 ? categoryInfo.regUserName : categoryInfo.regUserNameEn != null ? categoryInfo.regUserNameEn : categoryInfo.regUserName }}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.007","생성일") }}</dt>
                        <dd>{{$moment(categoryInfo.regDate).format('YYYY.MM.DD')}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.008","수정자") }}</dt>
                        <dd>{{ defaultLanguage.indexOf('ko') != -1 ? categoryInfo.modUserName : categoryInfo.modUserNameEn != null ? categoryInfo.modUserNameEn : categoryInfo.modUserName }}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.009","수정일") }}</dt>
                        <dd>{{$moment(categoryInfo.modDate).format('YYYY.MM.DD')}}</dd>
                    </dl>
                </li>
            </ul>
            <h2 v-if="categoryInfo.docGrade == 'SECRET'" >{{ $i18nUtil.trans("title.ShareInfoManageDetail.002","카테고리 멤버 정보") }}</h2> 
            <ul class="list-table" v-if="categoryInfo.docGrade == 'SECRET'">
                <li v-if="categoryInfo.docGrade == 'SECRET'">
                    <dl> 
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.010","운영자") }}</dt>
                        <dd>
                            <div class="dropdown ty1 relative">
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn ref="btnAddAdmin" v-bind="attrs" v-on="on">{{ $i18nUtil.trans("message.ShareInfoManageDetail.012","추가") }}</v-btn>
                                    </template>
                                    <div class="dropdown-list">
                                        <MemberCallSearch 
                                            :categoryInfo="categoryInfo"
                                            :memberList="memberList" 
                                            :memberType="'MANAGER'"
                                            :toggleBtn="$refs.btnAddAdmin"
                                            @selectedManagerUser="addManageList"/>
                                    </div>
                                </v-menu>
                            </div>
                            <div class="member_grp">
                                <div class="scroll">
                                    <div v-for="(user , idx ) in managerList" :key="'manager_'+idx">
                                        {{ defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn : user.userName }} 
                                        <button type="button"  @click="deleteManagerMember(user,idx)">삭제</button></div> 
                                </div>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{ $i18nUtil.trans("message.ShareInfoManageDetail.011","멤버") }}</dt>
                        <dd>
                            <div class="dropdown ty1 relative">
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn ref="btnAddMember" v-bind="attrs" v-on="on">{{ $i18nUtil.trans("message.ShareInfoManageDetail.012","추가") }}</v-btn>
                                    </template>
                                    <div class="dropdown-list">
                                        <MemberCallSearch 
                                            :categoryInfo="categoryInfo"
                                            :memberList="memberList" 
                                            :memberType="'MEMBER'"
                                            :toggleBtn="$refs.btnAddMember"
                                            @selectedMemberUser="addNormalList"/>
                                    </div>
                                </v-menu>
                            </div> 
                            <div class="num" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명', {cnt: normalList.length})"></div>
                            <div class="member_grp">
                                <div class="scroll">
                                    <div v-for="(user , idx ) in normalList" :key="'normal_'+idx">
                                        {{ defaultLanguage.indexOf('ko') != -1 ? user.userName : user.userNameEn != null ? user.userNameEn : user.userName }} 
                                        <button type="button" @click="deleteNormalmember(user,idx)">삭제</button></div> 
                                </div>
                            </div>
                        </dd>
                    </dl>
                </li>
            </ul>
        </div>
        <div class="btn_box clear">
            <!-- <button type="button" class="btn-primary-medium" v-if="myGrade != 'MEMBER'" @click="deleteCategory()">삭제</button>
            <button type="button" class="btn-primary-medium black" v-if="myGrade != 'MEMBER'" @click="updateCategory()">수정</button> -->
            <!-- || myGrade == 'MANAGER'삭제 버튼 운영자에겐 숨김 , 관리자에게만 노출 .수정  -->
            <button type="button" class="btn-primary-medium fl" v-if="shareInfoManageYn" @click="deleteCategory()">{{ $i18nUtil.trans("button.delete","삭제") }}</button>
            <button type="button" class="btn-primary-medium" @click="listView()">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
            <button type="button" class="btn-primary-medium black" v-if="shareInfoManageYn || docGrade != 'NORMAL'" @click="updateCategory()">{{ $i18nUtil.trans("button.modify","수정") }}</button>
        </div>

    </div><!-- //ifs004 -->
</template>

<script>  
import { mapState, mapActions, mapMutations } from "vuex";
import Vue from "vue";
import ConfirmModal from "@/components/cowork/general/project/modal/ConfirmModal";
import MemberCallSearch from "@/components/cowork/general/cooperation/modal/MemberCallSearch";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default { 
    components:{
        MemberCallSearch
    },
    data() {
        return {
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },
            categoryInfo:[],
            categoryName:"",
            docGrade:"",
            //:"MANAGER",  // 어차피 관리자만 접근함 . 
            categoryListLength:0,

            myUserId : null,
            myGrade : null,
            //검색 
            isSearch : false,
            userList:[],

            memberList:[],
            managerList:[],
            normalList:[],

            managerIds:[],
            normalIds:[],
            originManagerIds:[],
            originNormalIds:[],

            managerChange:false,
            normalChange:false,

            addManagerUserList :[],
            addNormalUserList: [],
            deleteManagerUserList:[],
            deleteNormalUserList:[],
            updateManagerUserList:[],
            updateNormalUserList:[],

            errorFolderName : false,

            checkBytes: 0,
            maxBytes: 150, 
            error: false, 

            delKeyActive:false,

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        };
    },
    computed:{
        ...mapState("shareInfo", ["shareInfoManageYn"]),
    },
    methods: { 
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION","COWORK_REST_ACTION"]),
        ...mapActions("modals", ["showDialog", "showToast", "showModal"]),
        setCategoryInfo(item, categoryListLength, myUserId){   
            this.myUserId = myUserId;
            this.categoryListLength = categoryListLength;
            this.categoryInfo = item; 
            this.categoryName = item.categoryName; 
            this.docGrade = item.docGrade == "NORMAL" || item.docGrade == null ? "NORMAL" : "SECRET";
         
            this.getMemberList(item);
        },
        getMemberList(item){  
            let obj = this;
            let reqData = {};
            reqData.req = {
                categoryMid: item.categoryMid,
                groupId : item.groupId
            };
            reqData.url = "/api/copaper/infoshare/getShareCategoryMember";
            //reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
            reqData.method = "post";
            obj
                .COWORK_REST_ACTION(reqData)
                .then((res) => {
                    this.memberList = res.result.categoryUserList;   
                   
                    this.myUserId = res.result.userId; 

                    if(!this.shareInfoManageYn){
                        const result1 = res.result.categoryUserList.filter(function(user){
                            return user.userId == obj.myUserId;
                        });
                        this.myGrade = result1[0].userGrade;     
                    }
                    
                    if(this.memberList != null && this.memberList.length != 0){
                        this.setMemberList(this.memberList);
                    }else{
                        this.setMemberList([]);
                    }
                      
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        listView(){
            history.back();
            // let param={
            //         categoryMain:true,
            //         categoryDetail:false, 
            //     }
            // this.$emit("view_Change",param); 
        },
        deleteCategory(){
            let obj = this;
            obj.showConfirmDialog(                  
                { width:"400px" },
                obj.$i18nUtil.trans("title.dialog.notice","알림"), obj.$i18nUtil.trans('AB033.002'),
                obj.$i18nUtil.trans("button.dialog.delete","삭제"), obj.callBackDeleteCategory,
                { categoryInfo : obj.categoryInfo }, obj.$i18nUtil.trans("button.dialog.cancel","취소"), null
            );  
        },
        callBackDeleteCategory(item){
            this.$emit('delete_category',item.modalParam.categoryInfo);
        },
        updateCategory(){
            let obj = this;
            obj.showConfirmDialog(                  
                { width:"400px" },
                obj.$i18nUtil.trans("title.dialog.notice","알림"), obj.$i18nUtil.trans("message.dialog.modify","수정하시겠습니까?"),
                obj.$i18nUtil.trans("button.dialog.modify","수정"), obj.callBackUpdateCategory,
                {}, obj.$i18nUtil.trans("button.dialog.cancel","취소"), null
            );
        },
        callBackUpdateCategory(){
            /*  if(this.categoryName == this.categoryInfo.categoryName || this.docGrade == this.categoryInfo.docGrade){
                alert("변경된 사항이 없습니다. ");
            } */ 
            if(this.categoryName == ''){
                this.errorFolderName=true; 
                return;
            }else if(this.error){ 
                return;
            }else{
                for(let k in this.originManagerIds){
                    if(this.normalIds.indexOf(this.originManagerIds[k]) != -1){ 
                        let param={
                            userId : this.originManagerIds[k],
                            currentUserGrade : "MANAGER"
                        }
                        this.updateNormalUserList.push(param);
                    }
                }


                for(let k in this.originNormalIds){
                    if(this.managerIds.indexOf(this.originNormalIds[k]) != -1){
                        let param={
                            userId:this.originNormalIds[k],
                            currentUserGrade:"MEMBER"
                        }
                        this.updateManagerUserList.push(param);
                    }
                }
    
                let addOrUpdateUserId = {}; 
                if(this.managerChange || this.normalChange){
                    addOrUpdateUserId.addManagerUserList = this.addManagerUserList;
                    addOrUpdateUserId.deleteManagerUserList = this.deleteManagerUserList;
                    addOrUpdateUserId.addNormalUserList = this.addNormalUserList;
                    addOrUpdateUserId.deleteNormalUserList = this.deleteNormalUserList;
                    addOrUpdateUserId.updateManagerUserList = this.updateManagerUserList;
                    addOrUpdateUserId.updateNormalUserList = this.updateNormalUserList;
                    addOrUpdateUserId.categoryInfo= this.categoryInfo;  
                    // this.$emit("addOrUpdate_userId" , addOrUpdateUserId);
                }else{
                    addOrUpdateUserId=null;
                } 

                let param ={
                    categoryName : this.categoryName,
                    docGrade : this.docGrade,
                    categoryMid : this.categoryInfo.categoryMid, 
                } 
                this.$emit("update_category", param, addOrUpdateUserId);

                this.addManagerUserList     = [];
                this.deleteManagerUserList  = [];
                this.addNormalUserList      = [];
                this.deleteNormalUserList   = [];
                this.updateManagerUserList  = [];
                this.updateNormalUserList   = [];
                this.categoryInfo           = [];
            }  
        },
        setSortNo(idx,item){ 
            event.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.remove('active');
            this.categoryInfo.sort = idx;
            let obj = this;
            let reqData = {};
            reqData.params ={
                categoryMid : this.categoryInfo.categoryMid, 
                sortNo : idx
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/setShareCategorySortNo";
            reqData.method = "post";
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                    
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        searchByKeyword(event) {
            if (event.target.value.length > 1) {
                this.isSearch = true;

                /* 부서 & 유저 */
                let searchKeyword = event.target.value;
                let searchCondition = "user";

                let obj = this;
                let reqData = {};
                reqData.params ={
                    searchKeyword: event.target.value, 
                };
                reqData.req = obj.req;
                reqData.url = "/api/auth/org/searchByUserName";
                reqData.method = "post";

                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(function (data) {
                    obj.userList = data.result; 
                })
                .catch(function (err) {
                    console.log(err);
                });
            } else {
                this.isSearch = false;
            }
        },
        joinCheck(userId, deptId) { 
            const obj = this; 
            for (let i = 0; i < obj.memberList.length; i++) {
                if (userId == obj.memberList[i].userId) {
                    return true;
                } else {
                    continue;
                }
            }
            return false;
        },
        addManageList(item){ 
            // event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');
             

            if(this.managerIds.indexOf(item.userId) == -1){
                this.managerIds.push(item.userId);
                this.managerChange=true; 
                let jsonString = JSON.stringify(this.managerList); 
                let jsonItem = JSON.stringify(item); 
                if(this.managerList.length != 0 ){
                    jsonString  = jsonString.substring(0,jsonString.length-1)+","+jsonItem.substring(0,jsonItem.length)+"]"; 
                }else{
                    jsonString  = jsonString.substring(0,jsonString.length-1) + jsonItem.substring(0,jsonItem.length)+"]"; 
                } 
                this.managerList = JSON.parse(jsonString); 
                 
                if(this.normalIds.indexOf(item.userId) != -1){   
                    this.normalIds.splice(this.normalIds.indexOf(item.userId),1);
                    const result = this.normalList.filter(function(user){
                        return user.userId != item.userId;
                    });
                    this.normalList = result; 

                    if(this.originNormalIds.indexOf(item.userId) == -1){ 
                        this.addNormalUserList.splice(this.addNormalUserList.indexOf(item.userId),1);
                        this.addManagerUserList.push(item.userId);
                    }     
                }else{
                    if(this.originManagerIds.indexOf(item.userId) == -1 && this.originNormalIds.indexOf(item.userId) == -1){
                        this.addManagerUserList.push(item.userId);
                    }

                    if(this.deleteManagerUserList.indexOf(item.userId) != -1){ 
                        this.deleteManagerUserList.splice(this.deleteManagerUserList.indexOf(item.userId),1);
                    }
                    if(this.deleteNormalUserList.indexOf(item.userId) != -1){ 
                        this.deleteNormalUserList.splice(this.deleteNormalUserList.indexOf(item.userId),1);
                    }
                }  
            }
        },
        addNormalList(item){
            // event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');
            

            if( this.normalIds.indexOf(item.userId) == -1){ 
                if( this.managerIds.indexOf(item.userId) != -1  ){  
                    if(this.managerIds.length <= 1){ 
                        const dialogInfo = {
                            obj: this.$modal,
                            component: Dialog,
                            title : this.$i18nUtil.trans("title.dialog.notice","알림"),
                            button : this.$i18nUtil.trans("button.dialog.confirm","확인"),
                            contents : this.$i18nUtil.trans("AB064"),
                        };
                        this.showDialog(dialogInfo);
                        return;
                    }else{
                        this.normalIds.push(item.userId);
                        this.normalChange=true;
                        let jsonString = JSON.stringify(this.normalList); 
                        let jsonItem = JSON.stringify(item); 
                        if(this.normalList.length != 0 ){
                            jsonString  = jsonString.substring(0,jsonString.length-1)+","+jsonItem.substring(0,jsonItem.length)+"]"; 
                        }else{
                            jsonString  = jsonString.substring(0,jsonString.length-1) + jsonItem.substring(0,jsonItem.length)+"]"; 
                        } 
                        this.normalList = JSON.parse(jsonString);  
                        this.managerIds.splice(this.managerIds.indexOf(item.userId),1);
                        const result = this.managerList.filter(function(user){
                            return user.userId != item.userId;
                        });
                        this.managerList = result; 
    
                        //update
                        if(this.originManagerIds.indexOf(item.userId) == -1){ 
                            this.addManagerUserList.splice(this.addManagerUserList.indexOf(item.userId),1);
                            this.addNormalUserList.push(item.userId);
                        }
                    }
                }else{ 
                    this.normalIds.push(item.userId);
                    this.normalChange=true;
                    let jsonString = JSON.stringify(this.normalList); 
                    let jsonItem = JSON.stringify(item); 
                    if(this.normalList.length != 0 ){
                        jsonString  = jsonString.substring(0,jsonString.length-1)+","+jsonItem.substring(0,jsonItem.length)+"]"; 
                    }else{
                        jsonString  = jsonString.substring(0,jsonString.length-1) + jsonItem.substring(0,jsonItem.length)+"]"; 
                    } 
                    this.normalList = JSON.parse(jsonString);  
                    if(this.originNormalIds.indexOf(item.userId) == -1 && this.originManagerIds.indexOf(item.userId) == -1){
                        this.addNormalUserList.push(item.userId);
                    }

                    if(this.deleteNormalUserList.indexOf(item.userId) != -1){ 
                        this.deleteNormalUserList.splice(this.deleteNormalUserList.indexOf(item.userId),1);
                    }
                    if(this.deleteManagerUserList.indexOf(item.userId) != -1){ 
                        this.deleteManagerUserList.splice(this.deleteManagerUserList.indexOf(item.userId),1);
                    }
                }  
            } 
        },
        deleteNormalmember(user,idx){ 
            this.normalChange=true; 
            this.normalList.splice(idx,1);  
            this.normalIds.splice(this.normalIds.indexOf(user.userId),1);
            
            if(this.originNormalIds.indexOf(user.userId) != -1){
                this.deleteNormalUserList.push(user.userId);
            }else if(this.originManagerIds.indexOf(user.userId) != -1){
                this.deleteManagerUserList.push(user.userId);
            }

            if(this.addNormalUserList.indexOf(user.userId) != -1){
                this.addNormalUserList.splice(this.addNormalUserList.indexOf(user.userId),1);
            } 
        },
        deleteManagerMember(user,idx){ 
            if(this.managerIds.length <= 1){ 
                const dialogInfo = {
                    obj: this.$modal,
                    component: Dialog,
                    title : this.$i18nUtil.trans("title.dialog.notice","알림"),
                    button : this.$i18nUtil.trans("button.dialog.confirm","확인"),
                    contents : this.$i18nUtil.trans("AB064"),
                };
                this.showDialog(dialogInfo);
            }else{  
                this.managerChange=true; 
                this.managerList.splice(idx,1);
                this.managerIds.splice(this.managerIds.indexOf(user.userId),1);

                if(this.originNormalIds.indexOf(user.userId) != -1){
                    this.deleteNormalUserList.push(user.userId);
                }else if(this.originManagerIds.indexOf(user.userId) != -1){
                    this.deleteManagerUserList.push(user.userId);
                }

                if(this.addManagerUserList.indexOf(user.userId) != -1){
                    this.addManagerUserList.splice(this.addManagerUserList.indexOf(user.userId),1);
                }
            }
                
        },
        setMemberList(memberList){
            this.managerList = this.memberList.filter(function(user){
                return user.userGrade == "MANAGER";
            }); 
            this.originManagerIds=[];
            this.managerIds=[];
            for(let k in this.managerList){
                if(this.managerIds.indexOf(this.managerList[k].userId) == -1){
                    this.managerIds.push(this.managerList[k].userId);
                    this.originManagerIds.push(this.managerList[k].userId);
                }
            }

            this.normalList =  this.memberList.filter(function(user){ 
                return user.userGrade == "MEMBER";
            });
            this.originNormalIds=[];
            this.normalIds=[];
            for(let k in this.normalList){
                if(this.normalIds.indexOf(this.normalList[k].userId) == -1){
                    this.normalIds.push(this.normalList[k].userId);
                    this.originNormalIds.push(this.normalList[k].userId);
                }
            }


        },
        /* byte 체크 */
        displayBytes(byteLength, categoryName, _event) {
            let obj = this;
            categoryName = _event.target.value;
            obj.categoryName = categoryName;
            let checkBytes = obj.getByteLength(obj.categoryName);
            obj.checkBytes = checkBytes;
            obj.error = false;
            if(checkBytes > byteLength) {
              obj.error = true;
            }
            if(checkBytes > 0) {
              obj.errorFolderName = false;
            }
        },
        getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
        },
        cutByteLength(data, len) {
            if (s == null || s.length == 0) {
                return 0;
            }
            var size = 0;
            var rIndex = s.length;
            for ( var i = 0; i < s.length; i++) {
                size += this.charByteSize(s.charAt(i));
                if( size == len ) {
                    rIndex = i + 1;
                    break;
                } else if( size > len ) {
                    rIndex = i;
                    break;
                }
            }
            return s.substring(0, rIndex);
        },
        charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        },

    }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/manage/components/ShareInfoManageDetail.vue